import Layout from '../../internal/Layout.vue'
import IAagent from './KnowledgeTable.vue'

const IAagentRoutes = {
  component: Layout,
  children: [
    {
      name: 'IAagent',
      path: '/IAagent',
      component: IAagent,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
  ]
}

export default IAagentRoutes